import React from 'react';

import * as S from './OtaReview.styles';

const OtaReview = ({hotelRating, ratingCount}) => {
  return (
    <S.HotelReviewWrapper>
      <S.ReviewWrapper hotelRating={hotelRating}>
        <div>
          <S.FlexBox>
            <S.AverageRating>{hotelRating}</S.AverageRating>
            /5
          </S.FlexBox>
          {!!ratingCount && (
            <S.ReviewCountTextWrapper>{ratingCount} Ratings</S.ReviewCountTextWrapper>
          )}
        </div>
      </S.ReviewWrapper>
      <S.ReviewCountWrapper>
        <S.ReviewSubText>Based on</S.ReviewSubText>
        <S.ReviewCountText>All Ratings & Reviews</S.ReviewCountText>
      </S.ReviewCountWrapper>
    </S.HotelReviewWrapper>
  );
};

export default OtaReview;
